var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColcomIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 216.74,
    height: 94.675,
    viewBox: "0 0 216.74 94.675",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_34",
    transform: "translate(-149 -108.325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_25",
    transform: "translate(149 178.242)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2636",
    d: "M370.2,94.012a5.054,5.054,0,0,0-4.474,1.974q-1.367,1.974-1.367,6.489,0,3.916,1.311,5.518t4.531,1.6h8.22v4.143h-8.463a16.044,16.044,0,0,1-4.4-.477,9.006,9.006,0,0,1-5.753-5.4,15.349,15.349,0,0,1-.914-5.591q0-6.311,2.735-9.313t8.479-3h8.317v4.062Z",
    transform: "translate(-358.886 -89.481)",
    fill: "#dc3d3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2637",
    d: "M481.028,99.425q0-6.133,2.934-9.127t8.935-2.994q6.048,0,8.951,3.026t2.9,9.337q0,6.311-2.9,9.353t-8.951,3.042q-6.113,0-8.992-3.058t-2.878-9.58M492.9,91.383a5.766,5.766,0,0,0-4.809,2.007Q486.5,95.4,486.5,99.458q0,4.4,1.543,6.449a6.786,6.786,0,0,0,9.7.016q1.574-2.031,1.575-6.254,0-4.24-1.575-6.262a5.757,5.757,0,0,0-4.841-2.023",
    transform: "translate(-459.361 -87.305)",
    fill: "#dc3d3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2638",
    d: "M640.9,113.737a16.269,16.269,0,0,1-4.952-.558,7.089,7.089,0,0,1-2.9-1.934,6.989,6.989,0,0,1-1.667-2.783,15.337,15.337,0,0,1-.485-4.369V89.95h5v13.981a15.735,15.735,0,0,0,.186,2.937,3.016,3.016,0,0,0,.639,1.367,3.918,3.918,0,0,0,1.747,1.2,9.138,9.138,0,0,0,2.864.356h5.89v3.948Z",
    transform: "translate(-582.646 -89.481)",
    fill: "#dc3d3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2639",
    d: "M740.819,94.012a5.054,5.054,0,0,0-4.474,1.974q-1.367,1.974-1.367,6.489,0,3.916,1.311,5.518t4.531,1.6h8.22v4.143h-8.463a16.045,16.045,0,0,1-4.4-.477,9.006,9.006,0,0,1-5.753-5.4,15.348,15.348,0,0,1-.914-5.591q0-6.311,2.735-9.313t8.479-3h8.318v4.062Z",
    transform: "translate(-663.761 -89.481)",
    fill: "#dc3d3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2640",
    d: "M851.65,99.425q0-6.133,2.934-9.127t8.935-2.994q6.048,0,8.951,3.026t2.9,9.337q0,6.311-2.9,9.353t-8.951,3.042q-6.113,0-8.992-3.058t-2.878-9.58m11.869-8.042a5.765,5.765,0,0,0-4.809,2.007q-1.592,2.007-1.591,6.068,0,4.4,1.543,6.449a6.786,6.786,0,0,0,9.7.016q1.574-2.031,1.575-6.254,0-4.24-1.575-6.262a5.757,5.757,0,0,0-4.841-2.023",
    transform: "translate(-764.235 -87.305)",
    fill: "#dc3d3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2641",
    d: "M1004.715,89.95h7.346l6.068,18.253L1024.2,89.95h7.314v23.787h-4.9l.4-18.528-6.1,18.528h-5.308l-6.295-18.723.5,18.723h-5.1Z",
    transform: "translate(-890.147 -89.481)",
    fill: "#dc3d3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2642",
    d: "M1185.166,103.834V99.627h11.829v14.111h-10.761a16.531,16.531,0,0,1-4.571-.486,9,9,0,0,1-5.729-5.4,15.353,15.353,0,0,1-.914-5.591q0-6.295,2.743-9.3t8.471-3.01h10.761v4.094h-10.761a4.9,4.9,0,0,0-4.3,1.909q-1.351,1.909-1.351,6.085,0,3.9,1.343,5.647a5.086,5.086,0,0,0,4.3,1.748h5.631v-5.6Z",
    transform: "translate(-1030.24 -89.481)",
    fill: "#2e417b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2643",
    d: "M1322.156,89.951h10.858a26.86,26.86,0,0,1,4.385.283,7.167,7.167,0,0,1,2.605.9,6.734,6.734,0,0,1,2.452,2.71,8.553,8.553,0,0,1,.833,3.859,8.985,8.985,0,0,1-.68,3.665,6.165,6.165,0,0,1-2.071,2.532,7.478,7.478,0,0,1-2.678,1.173,22.522,22.522,0,0,1-4.636.348h-6.068v8.317h-5Zm10.793,4.24h-5.793v7.023h6.1a5.406,5.406,0,0,0,3.366-.866,3.839,3.839,0,0,0,.024-5.356,6.393,6.393,0,0,0-3.7-.8",
    transform: "translate(-1151.275 -89.482)",
    fill: "#2e417b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2644",
    d: "M1474.769,94.191h-12.363a4.658,4.658,0,0,0-2.921.744,2.845,2.845,0,0,0-.931,2.363,2.359,2.359,0,0,0,.793,1.942,3.672,3.672,0,0,0,2.362.647h6.619q4.11,0,5.85,1.553t1.74,5.178q0,3.673-2.007,5.4t-6.311,1.724h-13.318V109.5h12.525a5.393,5.393,0,0,0,3.01-.623,2.358,2.358,0,0,0,.874-2.063,2.543,2.543,0,0,0-.8-2.12,4.53,4.53,0,0,0-2.743-.631h-5.906q-4.11,0-6.011-1.642t-1.9-5.186q0-3.787,2-5.534t6.351-1.748h13.091Z",
    transform: "translate(-1259.177 -89.482)",
    fill: "#2e417b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_24",
    transform: "translate(229 108.325)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2645",
    d: "M93.6,18.189c7.231-10.61,20.221-8.437,25.219.125l13.61-7.843C121.892-7.119,96.214-1.2,93.6,18.189",
    transform: "translate(-76.992 0)",
    fill: "#2e417b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2646",
    d: "M176.785,103.236c5.6,11.549-2.782,21.676-12.717,21.714l.007,15.673a20.82,20.82,0,0,0,12.711-37.387",
    transform: "translate(-134.963 -84.922)",
    fill: "#2e417b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2647",
    d: "M29.191,87.863C16.269,86.909,11.631,74.448,16.6,65.739L2.89,57.805c-10.08,18.125,8.028,37.586,26.3,30.058",
    transform: "translate(0 -47.551)",
    fill: "#2e417b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColcomIcon);
export default __webpack_public_path__ + "static/media/colcomIcon.acae75030aee49a1a5d0eec6b841b4d1.svg";
export { ForwardRef as ReactComponent };